<script setup>
defineProps({
  entries: { type: Array, required: true },
})
</script>

<template>
  <p v-if="!entries.length" class="text-sm text-slate-500">
    Nenhuma atualização publicada ainda.
  </p>

  <ol v-else class="relative space-y-5">
    <li v-for="(entry, i) in entries" :key="entry.at" class="relative flex gap-4">
      <span
        v-if="i < entries.length - 1"
        class="absolute left-[17px] top-10 h-[calc(100%+4px)] w-0.5 bg-slate-100"
        aria-hidden="true"
      />
      <span
        class="relative z-10 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-up-navy text-[10px] font-bold text-white"
        aria-hidden="true"
      >UP</span>
      <div class="min-w-0 pt-0.5">
        <p class="flex flex-wrap items-baseline gap-x-3">
          <span class="font-semibold text-up-navy">{{ entry.author }}</span>
          <time class="text-xs text-slate-500">{{ entry.at }}</time>
        </p>
        <p class="mt-1 text-sm leading-relaxed text-slate-600">{{ entry.text }}</p>
      </div>
    </li>
  </ol>
</template>
